import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImageAltText: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="image-alt-text"><path d="M6.75 17.25H12.25M15.25 17.25H17.25M20.25 14.25V3.75H3.75V12.0577V14.25M20.25 14.25V20.25H3.75V14.25M20.25 14.25H14.2767H3.75M4.29375 11.5L7.95 7.75L13.7745 13.7341M17.25 8.25C17.25 9.07843 16.5784 9.75 15.75 9.75C14.9216 9.75 14.25 9.07843 14.25 8.25C14.25 7.42157 14.9216 6.75 15.75 6.75C16.5784 6.75 17.25 7.42157 17.25 8.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconImageAltText;
